<template>
    <div
      class="col-md-12 ml-sm-auto col-lg-12 px-4 pt-6 pb-0">
          <v-row no-gutters>
            <v-col
              cols="6"
              sm="6"
              md="6"
              class="pl-2 d-flex align-center">
              <span class='font-sub-head mr-2'>{{TitleTxt}}</span>
              <span>({{showUploadImgItem.slice(1).length}}/{{limitImg}})</span>
            </v-col>
            <v-col
              cols="6"
              sm="6"
              md="6"
              class="d-flex align-center justify-end">
              <v-btn
                @click="clearAll()"
                outlined
                style="border-color: #8A8D93; color: #8A8D93;"
              >
                ลบทั้งหมด
                </v-btn
              >
            </v-col>
          </v-row>
          <v-divider class='m-divider'></v-divider>
            <v-row no-gutters>
              <v-col class="col-12">
                  <v-file-input
                    v-show="false"
                    @change="CheckFile"
                    v-model="imageBA"
                    :id="`fileInputimageBA${TypeKey}`"
                    hide-input
                    style="display: none"
                    :ref="`trigger_file${TypeKey}`"
                    multiple
                    required
                  >
                  </v-file-input>
                  <v-slide-group
                    v-model="model"
                    active-class="success"
                    show-arrows
                  >
                    <v-slide-item
                      v-for="(value, index) in showUploadImgItem"
                      :key="index"
                      v-slot="{ active, toggle }"
                    >
                      <v-card
                        v-if="index === 0"
                        color="#EFEEF0"
                        style="border: 1px dashed #C1BEC5; border-radius: 4px;"
                        class="ma-4"
                        height="100"
                        width="100"
                        @click="
                          toggle;
                          refUpload(TypeKey);
                        "
                      >
                        <v-row
                          class="fill-height"
                          style="margin-top: 2px;"
                          align="center"
                          justify="center"
                        >
                          <v-scale-transition>
                            <v-icon
                              style="color: black;"
                              size="30"
                              class="iconify"
                              data-icon="ps:plus"
                            >
                              mdi-plus
                            </v-icon>
                          </v-scale-transition>
                        </v-row>
                      </v-card>
                      <v-card v-else class="ma-4" height="100" width="100">
                        <v-badge
                          overlap
                          color="red"
                          icon="mdi-close"
                          @click.native="clearImg(index)"
                        >
                          <v-img
                            style="width: 100px;
                            height: 100px;
                            object-fit: cover;
                            border-radius: 4px;"
                            :src="value"
                          >
                          </v-img>
                        </v-badge>
                      </v-card>
                    </v-slide-item>
                  </v-slide-group>
              </v-col>
              <p v-if="checkErrors" type="error" class="required-img ml-4">{{ checkErrors }}</p>
            </v-row>
            <v-dialog
              v-model="dialogLoadingDialogs"
              persistent
              width="300"
            >
              <v-card
                color="primary"
                dark
              >
                <v-card-text>
                  กำลังจัดเตรียมข้อมูล กรุณารอสักครู่...
                  <v-progress-linear
                    indeterminate
                    color="white"
                    class="mb-0"
                  ></v-progress-linear>
                </v-card-text>
              </v-card>
            </v-dialog>
    </div>
</template>

<script>
import imageCompression from 'browser-image-compress'

export default {
  components: {},
  props: {
    minImg: {type: Number, required: true},
    limitImg: {type: Number, required: true},
    TitleTxt: {type: String, required: true},
    TypeKey: {type: String, required: true},
    checkError: {type: Number, default: 0},
    defaultArray: {type: Array},
    defaultInputArray: {type: Array}
  },
  data () {
    return {
      dialogLoadingDialogs: false,
      model: null,
      BeforeAfterOverlay: true,
      imageBA: null,
      imageNew: [],
      arrReturnVal: [],
      // showUploadImgItem: this.returnData()
      showUploadImgItem: this.defaultArray
    }
  },
  computed: {
    returnData () {
      if (this.defaultArray.length > 1) {
        return this.defaultArray
      } else {
        return ['']
      }
    },
    checkErrors () {
      if (this.checkError < this.minImg) {
        return 'กรุณาแนบรูปภาพ'
      } else {
        return 0
      }
    }
  },
  async mounted () {
    await this.firstPush()
  },
  methods: {
    firstPush () {
      for (const f of this.defaultInputArray) {
        this.arrReturnVal.push(f)
      }
    },
    clearAll () {
      let arrReturn = []
      this.showUploadImgItem = ['']
      this.imageBA = []
      this.arrReturnVal = []
      this.$emit('ReturnURL', {data: arrReturn, key: this.TypeKey, vals: []})
    },
    clearImg (i) {
      let arrReturn = []
      this.showUploadImgItem.splice(i, 1)
      // this.imageBA.splice(parseInt(i) - 1, 1)
      this.arrReturnVal.splice(parseInt(i) - 1, 1)
      arrReturn = [...this.showUploadImgItem]
      // this.arrReturnVal = [...this.arrReturnVal]
      arrReturn.shift()

      this.$emit('ReturnURL', {data: arrReturn, key: this.TypeKey, vals: this.arrReturnVal})
    },
    refUpload () {
      let fileUpload = document.getElementById(`fileInputimageBA` + this.TypeKey)
      if (fileUpload != null) {
        fileUpload.click()
      }
    },
    async convertBlobToFile (ee, filename) {
      if (!ee) {
        console.error('No Blob URL available')
        return
      }

      try {
      // Fetch the Blob from the URL
        const response = await fetch(ee)
        if (!response.ok) {
          throw new Error(`Failed to fetch Blob: ${response.statusText}`)
        }

        // Convert the response to a Blob
        const blob = await response.blob()

        // Convert the Blob to a File
        const file = new File([blob], filename, { type: this.mimeType })
        return file
      // You can now use the file object as needed
      } catch (error) {
        console.error('Error converting Blob to File:', error)
      }
    },
    async CheckFile () {
      this.dialogLoadingDialogs = true
      try {
        if (this.imageBA != null) {
        // เช็คจำนวนรูปภาพปัจจุบัน (ถ้าจำนวนรูปเดิม + จำนวนรูปที่อัปโหลดเข้าไปใหม่ ถ้ามากกว่า limitImg จะขึ้นแจ้งเตือน)
          if (this.showUploadImgItem.slice(1).length + this.imageBA.length > this.limitImg) {
            this.$swal('คำเตือน', `อัปโหลดรูปภาพได้สูงสุด ${this.limitImg} รูปเท่านั้น`, 'warning')
            this.dialogLoadingDialogs = false
            return
          }
          console.log('this.showUploadImgItem >>', this.showUploadImgItem)
          let SetImageUrl = ['']
          this.showUploadImgItem.shift()
          console.log('SetImageUrl : ', SetImageUrl)
          console.log('this.arrReturnVal : ', this.arrReturnVal)
          for (let i = 0; i < this.imageBA.length; i++) {
            const file = this.imageBA[i]
            // let sizeOriginal = file.size
            console.log('file original >> ', file)
            if (file) {
              let resizedImage = null
              if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
                this.showUploadImgItem.push('')
                this.arrReturnVal = []
                this.$swal('คำเตือน', `อัปโหลดรูปภาพเท่านั้น`, 'warning')
                this.dialogLoadingDialogs = false
                return
              }
              // if (this.TypeKey === 'beforeImage') {
              //   resizedImage = await this.resizeImage(file, file.name)
              // } else {
              resizedImage = await this.resizeImageV2(file, file.name)
              // }
              console.log('file.type >>' + file.type)
              // console.log('resizedImage >>' + this.TypeKey + ' : ', resizedImage['newFiles'])
              // console.log('resizedImage >>' + this.TypeKey + ' : ', resizedImage['resizedUrl'])
              SetImageUrl.push(resizedImage['resizedUrl'])
              let newFile = resizedImage['newFiles']
              newFile['TypeImgs'] = this.TypeKey
              this.arrReturnVal.push(newFile)
            // }
            // } catch (err) {
            //   alert('อุปกรณ์ไม่รองรับ !')
            // }
            }
          }
          this.showUploadImgItem = SetImageUrl.concat(this.showUploadImgItem)
          let arrReturn = null
          arrReturn = [...this.showUploadImgItem]
          arrReturn.shift()
          // for (const f of this.imageBA) {
          //   this.arrReturnVal.push(f)
          //   f['TypeImgs'] = this.TypeKey
          // }
          this.dialogLoadingDialogs = false
          this.$emit('ReturnURL', {data: arrReturn, key: this.TypeKey, vals: this.arrReturnVal, show: this.showUploadImgItem})
        }
      } catch (err) {
        console.log('err', err)
        // SetImageUrl = ['']
        this.showUploadImgItem.push('')
        this.arrReturnVal = []
        this.$swal('คำเตือน', `อัปโหลดรูปภาพเท่านั้น.`, 'warning')
        this.dialogLoadingDialogs = false
      }
    },
    async covBlob2File (imgUrl, fileNmae) {
      try {
        const response = await fetch(imgUrl, {mode: 'cors'})
        const blob = await response.blob()
        const mime = blob.type || 'image/png'
        const file = new File([blob], fileNmae, { type: mime })
        return file
      } catch (err) {
        alert('อุปกรณ์ไม่รองรับ !!')
        return false
      }
    },
    resizeImage (file, names) {
      return new Promise((resolve, reject) => {
        // แปลงไฟล์รูปเป็น URL ชั่วคราว
        const img = new Image()
        img.src = URL.createObjectURL(file)

        img.onload = () => {
          const canvas = document.createElement('canvas')
          const ctx = canvas.getContext('2d')

          let { width, height } = img
          if (width > height) {
            width = 1000
            height = 750
          } else {
            width = 1000
            height = 1500
          }
          canvas.width = width
          canvas.height = height

          // ปรับขนาดรูปภาพลงใน canvas ที่กำหนดไว้
          ctx.drawImage(img, 0, 0, width, height)

          canvas.toBlob(
            (blob) => {
              if (blob) {
                // แปลงรูปเป็น blob
                const resizedUrl = URL.createObjectURL(blob)
                const newFiles = new File([blob], names, { type: 'image/jpeg' })
                // คืนค่าเป็น object
                resolve({ resizedUrl, newFiles })
              } else {
                reject(new Error('Blob creation failed'))
              }
            },
            'image/jpeg',
            0.8 // ลดขนาดรูปเหลือ 80%
          )
        }

        img.onerror = (err) => {
          reject(err)
        }
      })
    },
    // { resizedUrl, newFiles }
    async resizeImageV2 (file, names) {
      if (file) {
        const options = {
          maxSizeMB: 1, // Maximum size of the compressed image (in MB)
          maxWidthOrHeight: 800, // Maximum width or height of the compressed image
          useWebWorker: true // Whether to use a Web Worker for compression
        }

        try {
          const renamedFile = new File([file], names, { type: file.type })
          const compressedFile = await imageCompression(renamedFile, options)
          const compressedImageUrl = URL.createObjectURL(compressedFile)
          return { 'resizedUrl': compressedImageUrl, 'newFiles': compressedFile }
        } catch (error) {
          this.$swal('คำเตือน', `อัปโหลดรูปภาพเท่านั้น!`, 'warning')
          console.error('Error during image compression', error)
        }
      }
    }

  }
}
</script>

<style>
.font-sub-head{
  font-size: 16px;
  font-weight: 600;
}
.m-divider{
  margin-top: 10px;
  margin-bottom: 10px;
}
.required-img{
  color: #ff5252;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/PdfForm/multiUpload.vue